<template>
    <div class="flex flex-col justify-between min-h-screen pb-4">
        <Head>
            <link
                rel="apple-touch-icon"
                sizes="180x180"
                href="/apple-touch-icon.png"
            />
            <link
                rel="icon"
                type="image/png"
                sizes="32x32"
                href="/favicon-32x32.png"
            />
            <link
                rel="icon"
                type="image/png"
                sizes="16x16"
                href="/favicon-16x16.png"
            />
            <link rel="manifest" href="/site.webmanifest" />
            <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#62338d">
            <meta name="msapplication-TileColor" content="#62338d">
            <meta name="theme-color" content="#ffffff" />
        </Head>

        <div>
            <Navbar />
            <main class="pt-20 lg:pt-0">
                <slot />
            </main>
        </div>
        <Footerbar />
    </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Navbar from '~/components/Navbar.vue'
import Footerbar from '~/components/Footerbar.vue'

export default {
    components: {
        Navbar,
        Footerbar,
    },
}
</script>
